import { Link } from 'react-router-dom';
import { ArrowRight, Clock3, MapPinned, Phone } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF } from '../../../lib/contact';

const badges = ['24/7 direkt erreichbar', 'Berlin & Umland', 'Transparente Abwicklung'];

export default function EmergencyStrip() {
  return (
    <section aria-label="Kontakt und Vorteile" className="border-y border-white/10 bg-[#0c1018] text-white">
      <div className="mx-auto grid max-w-7xl gap-4 px-4 py-5 sm:px-6 lg:grid-cols-[0.85fr_1.15fr_0.9fr] lg:items-center lg:px-8">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-2xl border border-amber-400/25 bg-amber-400/10 text-amber-200">
            <Phone className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-semibold text-amber-100">Direktkontakt</p>
            <p className="mt-1 text-sm text-slate-300">Direkt anrufen statt weiterklicken.</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          {badges.map((item) => (
            <span key={item} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-200">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              {item}
            </span>
          ))}
        </div>

        <div className="flex flex-wrap gap-2 lg:justify-end">
          <Link
            to="/leistungen"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:border-amber-300/30 hover:bg-white/10"
          >
            Leistungen
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <Link
            to="/einsatzgebiete"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:border-amber-300/30 hover:bg-white/10"
          >
            Einsatzgebiete
            <MapPinned className="h-4 w-4" aria-hidden="true" />
          </Link>
          <a
            href={PHONE_HREF}
            className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-4 py-2.5 text-sm font-semibold text-slate-950 transition-colors hover:bg-amber-300"
          >
            <Clock3 className="h-4 w-4" aria-hidden="true" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
